export default __webpack_public_path__ + "static/media/logo3.8adb5c4b.jpg";